import { END_POINTS } from "../constants/urls";
import { CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

export const cmsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getFAQ: builder.query<
      CommonResponseType & { data: any },
      {
        page?: any;
        limit?: any;
        search?: any;
      }
    >({
      query: (params) => {
        const paramArray = [];
        let url = END_POINTS.getFAQ;
        if (params?.page) {
          paramArray.push(`page=${params?.page}`);
        }
        if (params?.limit) {
          paramArray.push(`limit=${params?.limit}`);
        }
        if (params?.search) {
          paramArray.push(`search=${params?.search}`);
        }
        if (paramArray?.length) {
          url += `?${paramArray.join("&")}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getCMS: builder.query<CommonResponseType & { data: any }, {}>({
      query: () => ({
        url: `${END_POINTS.getCMS}`,
        method: "GET",
      }),
    }),
    updateCMS: builder.mutation<CommonResponseType, { body: any }>({
      query: ({ body }) => ({
        url: `${END_POINTS.updateCMS}`,
        method: "PUT",
        body,
      }),
    }),
    getFAQById: builder.query<CommonResponseType & { data: any }, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getFAQById}/${id}`,
        method: "GET",
      }),
    }),
    addFAQ: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.addFAQ,
        method: "POST",
        body,
      }),
    }),
    updateFAQ: builder.mutation<CommonResponseType, { body: any; id: any }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateFAQ}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteFAQ: builder.mutation<CommonResponseType, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteFAQ}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddFAQMutation,
  useLazyGetFAQByIdQuery,
  useLazyGetFAQQuery,
  useUpdateFAQMutation,
  useDeleteFAQMutation,
  useLazyGetCMSQuery,
  useUpdateCMSMutation,
} = cmsApi;
